import { createSlice } from "@reduxjs/toolkit";

export const PreventiveGuidelinesSlice = createSlice({
  name: "PreventiveGuidelines",
  initialState: {
    GuidelinesData: [],
    FrequencyOptions: [],
    EditGuidelineData: null,

    Loading: false,
    SuccessMessage: "",
    ErrorMessage: "",
  },
  reducers: {
    getGuidelinesData: (state) => {
      state.Loading = true;
    },
    setGuidelinesData: (state, action) => {
      state.GuidelinesData = action.payload || [];
      state.Loading = false;
    },

    getFrequencyOptions: (state) => state,
    setFrequencyOptions: (state, action) => {
      state.FrequencyOptions = action.payload || [];
    },

    createGuidelineData: (state) => state,

    editGuidelineData: (state) => state,
    setEditGuidelineData: (state, action) => {
      state.EditGuidelineData = action.payload || null;
    },

    updateGuidelineData: (state) => state,

    clearEditGuidelineData: (state) => {
      state.EditGuidelineData = null;
    },

    deleteGuidelineData: (state) => state,

    toggleGuidelineStatus: (state) => state,

    setGuidelineSuccessMessage: (state, action) => {
      state.SuccessMessage = action.payload || "";
    },

    clearGuidelineSuccessMessage: (state) => {
      state.SuccessMessage = "";
    },

    setGuidelineErrorMessage: (state, action) => {
      state.ErrorMessage = action.payload || "";
    },

    clearGuidelineErrorMessage: (state) => {
      state.ErrorMessage = "";
    },
  },
});

export const {
  getGuidelinesData,
  setGuidelinesData,
  getFrequencyOptions,
  setFrequencyOptions,
  createGuidelineData,
  editGuidelineData,
  setEditGuidelineData,
  updateGuidelineData,
  clearEditGuidelineData,
  toggleGuidelineStatus,
  deleteGuidelineData,
  setGuidelineSuccessMessage,
  clearGuidelineSuccessMessage,
  setGuidelineErrorMessage,
  clearGuidelineErrorMessage,
} = PreventiveGuidelinesSlice.actions;

export default PreventiveGuidelinesSlice.reducer;
